import UsuarioCUPSPage from './UsuarioCUPSPage';

export default UsuarioCUPSPage;
